import { fetchJsonResponse } from '@/ai/api'
import { buildSingleEntityPrompt } from '@/ai/prompts'

export const generateSingleEntity = async ({
  workflow,
  cardTypes,
  name,
  entityDescription,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleEntityPrompt({
    workflow,
    cardTypes,
    name,
    entityDescription
  })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'entities',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
